//Product
const productSlides = document.getElementsByClassName('productSlide');
const productSlideOption = {
	type: "slide",
	pauseOnHover: false,
	pauseOnFocus: false,
	speed: 1000,
	perPage: 4,
	perMove: 1,
	gap: '2.1vw',
	arrows: false,
	breakpoints: {
		768: {
			perPage: 2,
		},
	},
};
for (let i = 0; i < productSlides.length; i++) {
	let productSlide = new Splide(productSlides[i], productSlideOption);
	productSlide.mount();
}

//Column
const columnSlides = document.getElementsByClassName('columnList');
const columnSlideOption = {
	type: "slide",
	pauseOnHover: false,
	pauseOnFocus: false,
	speed: 2000,
	perPage: 1,
	perMove: 1,
	arrows: false,
	pagination: false,
	destroy: true, // スライダーを破棄
	breakpoints: {
		768: {
			destroy: false,
			pagination: true,
			gap: "4px",
		},
	},
};
let columnSlide = new Splide(columnSlides[0], columnSlideOption);
columnSlide.mount();

//NEWS
const blogSlides = document.getElementById('homeBlog');
const blogSlideOption = {
	type: "slide",
	pauseOnHover: false,
	pauseOnFocus: false,
	speed: 1000,
	perPage: 1,
	perMove: 1,
	gap: '4vw',
	arrows: false,

};
let blogSlide = new Splide(blogSlides, blogSlideOption);
blogSlide.mount();

//Arrival
const arrivalSlides = document.getElementById('homeArrival');
const arrivalSlideOption = {
	type: "loop",
	pauseOnHover: false,
	pauseOnFocus: false,
	speed: 2000,
	perPage: 1,
	perMove: 1,
	arrows: false,
	direction: "ttb",
	height: "4em",
	autoplay: true,
	interval: 5000,
	pagination: false,
	breakpoints: {
		768: {
			height: "6em",
		},
	},
};
let arrivalSlide = new Splide(arrivalSlides, arrivalSlideOption);
arrivalSlide.mount();
